/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SendPatientMessage from 'DesignSystem/SendPatientMessage/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/SendSecurely/Content",
  onSubmit
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let patientImageIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'id',
})
let tabSubmitData = fromData.useDataSubmit({ viewPath,
context: 'tab',
})
  return (<React.Fragment
>
<SendPatientMessage
  viewPath={`${viewPath}/SendPatientMessage`}
 data="patient.id"
 patientId={patientIdValueData}
 data="patient_image.id"
 fileId={patientImageIdValueData}
 fileType="image"
 onSubmitPost={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 data="tab"
 onSubmit={tabSubmitData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
{children}
</React.Fragment>)
}